module.exports = __webpack_public_path__ + "img/c542ef6.jpg";